<template>
	<div>
		<el-dialog
			align-center
			v-model="state.dialogVisible"
			:title="dialogTitle"
			:width="dialogWidth"
			draggable
		>
			<div class="userAdd_man">
				<el-form ref="ruleForm" label-width="auto" :model="state.form" :rules="rules" class="userFrom">
					<el-row :gutter="0">
						<el-col :span="12" style="margin-bottom: 20px;">
							<el-form-item :label="t('field.username')" prop="username">
								<el-input v-model="state.form.username" :placeholder="t('userForm.phUsername')" :readonly="isFieldReadonly('username')" />
							</el-form-item>
						</el-col>
						<el-col v-if="!hideExtraFields" :span="12" style="margin-bottom: 20px;">
							<el-form-item :label="t('personnelList.colEnglishName')" prop="english_name">
								<el-input v-model="state.form.english_name" :placeholder="t('userForm.phEnglishName')" :readonly="isFieldReadonly('english_name')" />
							</el-form-item>
						</el-col>
						<el-col v-if="!hideExtraFields" :span="12" style="margin-bottom: 20px;">
							<el-form-item :label="t('personnelList.colIdCard')" prop="id_card">
								<el-input v-model="state.form.id_card" :placeholder="t('userForm.phIdCard')" :readonly="isFieldReadonly('id_card')" />
							</el-form-item>
						</el-col>
						<el-col v-if="!hideExtraFields" :span="24" style="margin-bottom: 20px;">
							<el-form-item :label="t('personnelList.colAddress')" prop="address">
								<el-input type="textarea" v-model="state.form.address" :placeholder="t('userForm.phAddress')" :rows="2" :readonly="isFieldReadonly('address')" />
							</el-form-item>
						</el-col>
						<el-col :span="12" style="margin-bottom: 20px;">
							<el-form-item :label="t('field.realName')" prop="real_name">
								<el-input v-model="state.form.real_name" :placeholder="t('userForm.phRealName')" :readonly="isFieldReadonly('real_name')" />
							</el-form-item>
						</el-col>
						<el-col :span="12" style="margin-bottom: 20px;">
							<el-form-item :label="t('field.mobile')" prop="mobile">
								<el-input v-model="state.form.mobile" :placeholder="t('userForm.phMobile')" :readonly="isFieldReadonly('mobile')" />
							</el-form-item>
						</el-col>
						<el-col :span="12" style="margin-bottom: 20px;">
							<el-form-item :label="t('field.email')" prop="email">
								<el-input v-model="state.form.email" :placeholder="t('userForm.phEmail')" :readonly="isFieldReadonly('email')" />
							</el-form-item>
						</el-col>
						<el-col v-if="showCaptainSelect && !state.form.id" :span="12" style="margin-bottom: 20px;">
							<el-form-item :label="t('personnelList.captainSelect')" prop="captain_id">
								<el-select
									v-model="state.form.captain_id"
									filterable
									clearable
									:placeholder="t('personnelList.captainSelectPh')"
									style="width: 100%"
								>
									<el-option
										v-for="item in state.captainOptions"
										:key="item.id"
										:label="`${item.real_name || item.realName || '-'}（ID:${item.id}）`"
										:value="item.id"
									/>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12" style="margin-bottom: 20px;">
							<el-form-item :label="t('field.role')" prop="role_id">
								<el-select
									v-model="state.form.role_id"
									:placeholder="t('common.pleaseSelect')"
									style="width: 100%"
									:disabled="isFieldReadonly('role_id') || lockRole"
									@change="onRoleChange"
								>
									<el-option v-for="(item, index) in roleOptions" :key="index" :label="item.label"
										:value="item.value" />
								</el-select>
							</el-form-item>
						</el-col>
						<el-col v-if="enableMenuPermission" :span="24" style="margin-bottom: 20px;">
							<el-form-item :label="t('userForm.accountRemark')" prop="account_remark">
								<el-input
									v-model="state.form.account_remark"
									type="textarea"
									:rows="2"
									maxlength="500"
									show-word-limit
									:placeholder="t('userForm.accountRemarkPh')"
									:readonly="isFieldReadonly('account_remark')"
								/>
							</el-form-item>
						</el-col>
						<el-col :span="12" style="margin-bottom: 20px;">
							<el-form-item :label="t('field.sex')" prop="sex">
								<el-select v-model="state.form.sex" :placeholder="t('common.pleaseSelect')" style="width: 100%" :disabled="isFieldReadonly('sex')">
									<el-option v-for="(item, index) in sexOptions" :key="index" :label="item.label"
										:value="item.value" />
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12" style="margin-bottom: 20px;">
							<el-form-item :label="t('personnelList.colStartDate')" prop="start_date">
								<el-date-picker style="width: 100%" v-model="state.form.start_date"
									type="datetime" value-format="YYYY-MM-DD HH:mm:ss" :placeholder="t('personnelList.colStartDate')" :disabled="isFieldReadonly('start_date')" />
							</el-form-item>
						</el-col>
						<el-col :span="12" style="margin-bottom: 20px;">
							<el-form-item :label="t('field.employment')" prop="employment">
								<el-switch v-model="state.form.employment" :active-value="1" :inactive-value="0"
									:active-text="t('status.onJob')" :inactive-text="t('status.offJob')" :disabled="isFieldReadonly('employment')" />
							</el-form-item>
						</el-col>
						<el-col :span="12" style="margin-bottom: 20px;">
							<el-form-item :label="t('field.status')" prop="status">
								<el-switch v-model="state.form.status" :active-value="1" :inactive-value="0"
									:active-text="t('status.enabled')" :inactive-text="t('status.disabled')" :disabled="isFieldReadonly('status')" />
							</el-form-item>
						</el-col>
						<el-col v-if="state.form.employment === 0" :span="12" style="margin-bottom: 20px;">
							<el-form-item :label="t('personnelList.colEndDate')" prop="end_date">
								<el-date-picker style="width: 100%" v-model="state.form.end_date"
									type="datetime" value-format="YYYY-MM-DD HH:mm:ss" :placeholder="t('personnelList.colEndDate')" :disabled="isFieldReadonly('end_date')" />
							</el-form-item>
						</el-col>
						<el-col v-if="state.form.employment === 0" :span="24" style="margin-bottom: 20px;">
							<el-form-item :label="t('userForm.resignationRemark')" prop="resignation_remark">
								<el-input type="textarea" v-model="state.form.resignation_remark" :placeholder="t('userForm.resignationRemarkPh')" :rows="3" :readonly="isFieldReadonly('resignation_remark')" />
							</el-form-item>
						</el-col>
						<template v-if="!hideSalaryFields">
							<el-col :span="12" style="margin-bottom: 20px;">
								<el-form-item :label="t('userForm.dailyPay')" prop="renewal">
									<el-input v-model="state.form.renewal" :placeholder="t('userForm.dailyPay')" />
								</el-form-item>
							</el-col>
							<el-col :span="12" style="margin-bottom: 20px;">
								<el-form-item :label="t('userForm.hourlyPay')" prop="otovertime">
									<el-input v-model="state.form.otovertime" :placeholder="t('userForm.hourlyPay')" />
								</el-form-item>
							</el-col>
							<el-col :span="12" style="margin-bottom: 20px;">
								<el-form-item :label="t('userForm.allowance')" prop="allowance">
									<el-input v-model="state.form.allowance" :placeholder="t('userForm.allowance')" />
								</el-form-item>
							</el-col>
						</template>
					</el-row>

					<div v-if="showSuperAdminHint" class="menu-permission-block">
						<p class="menu-permission-tip super-admin-tip">{{ t('userForm.superAdminTip') }}</p>
					</div>

					<div v-if="showMenuPermission" class="menu-permission-block">
						<div class="menu-permission-head">
							<span class="menu-permission-title">{{ t('userForm.menuPermission') }}</span>
							<div class="menu-permission-actions">
								<el-button link type="primary" @click="selectDefaultMenus">{{ t('userForm.restoreDefaultMenus') }}</el-button>
								<el-button link type="primary" @click="selectAllMenus">{{ t('userForm.selectAllMenus') }}</el-button>
								<el-button link type="primary" @click="clearAllMenus">{{ t('userForm.clearMenus') }}</el-button>
							</div>
						</div>
						<p class="menu-permission-tip">{{ t('userForm.menuPermissionTip') }}</p>
						<el-tree
							ref="menuTreeRef"
							class="menu-permission-tree"
							:data="menuPermissionTree"
							show-checkbox
							node-key="id"
							default-expand-all
							:props="menuTreeProps"
						/>
					</div>
				</el-form>
			</div>
			<template #footer>
				<div class="dialog-footer">
					<el-button @click="close">{{ t('common.cancel') }}</el-button>
					<el-button type="primary" @click="submit">
						{{ t('common.confirm') }}
					</el-button>
				</div>
			</template>
		</el-dialog>
	</div>
</template>

<script setup>
import {
	onMounted,
	reactive,
	ref,
	nextTick,
	defineEmits,
	defineProps,
	defineExpose,
	computed,
} from "vue";
import { saveApi, detailApi, pageListApi } from "@/api/system/personnel";
import { ElMessage } from "element-plus";
import { usePageI18n } from '@/composables/usePageI18n.js';
import { applyUserFormRules } from '@/utils/userFormI18n.js';
import {
	buildAdminMenuPermissionTree,
	getAllAdminMenuPermissionKeys,
	getDefaultNormalAdminPermissions,
	normalizeMenuPermissionPayload,
	parseMenuPermissions,
	resolveCheckedMenuKeys,
	ROLE_NORMAL_ADMIN,
	ROLE_SUPER_ADMIN,
} from "@/utils/adminMenuPermission.js";

const emit = defineEmits(["refresh"]);
const props = defineProps({
	title: {
		type: String,
		default: "人员新增",
	},
	addTitle: {
		type: String,
		default: "",
	},
	defaultRoleId: {
		type: Number,
		default: 1,
	},
	lockRole: {
		type: Boolean,
		default: false,
	},
	showCaptainSelect: {
		type: Boolean,
		default: false,
	},
	roleOptions: {
		type: Object,
		default: () => { },
	},
	statusOptions: {
		type: Object,
		default: () => { },
	},
	sexOptions: {
		type: Object,
		default: () => { },
	},
	hideExtraFields: {
		type: Boolean,
		default: false,
	},
	hideSalaryFields: {
		type: Boolean,
		default: false,
	},
	employmentOnlyEdit: {
		type: Boolean,
		default: false,
	},
	enableMenuPermission: {
		type: Boolean,
		default: false,
	},
});

const menuTreeRef = ref(null);
const menuPermissionTree = buildAdminMenuPermissionTree();
const menuTreeProps = {
	children: "children",
	label: "label",
};

const isFieldReadonly = (field) => {
	if (!props.employmentOnlyEdit) {
		if (field === 'role_id' && props.lockRole) {
			return true;
		}
		return field === 'username' && state.form.id > 0;
	}
	return field !== 'employment';
};

const dialogTitle = computed(() => {
	if (state.form.id > 0) {
		return props.title;
	}
	return props.addTitle || props.title;
});

const rules = reactive({
	username: [{ required: true, message: "", trigger: "blur" }],
	english_name: [{ message: "", trigger: "blur" }],
	id_card: [{ message: "", trigger: "blur" }],
	address: [{ message: "", trigger: "blur" }],
	captain_id: [{
		validator: (_rule, value, callback) => {
			if (!props.showCaptainSelect || state.form.id > 0) {
				callback();
				return;
			}
			if (!value) {
				callback(new Error(t('personnelList.captainSelectRequired')));
				return;
			}
			callback();
		},
		trigger: 'change',
	}],
});

const applyLabels = () => {
	applyUserFormRules(rules);
};
const { t } = usePageI18n(applyLabels);

const createDefaultForm = () => ({
	"id": 0,
	"username": "",
	"real_name": "",
	"email": "",
	"mobile": "",
	"sex": 1,
	"avatar_url": "",
	"role_id": 1,
	"captain_id": null,
	"status": 1,
	"english_name": "",
	"id_card": "",
	"address": "",
	"start_date": "",
	"end_date": "",
	"resignation_remark": "",
	"account_remark": "",
	"employment": 1,
	"renewal": 0,
	"otovertime": 0,
	"zhiovertime": 0,
	"belatepay": 0,
	"leaveearly": 0,
	"weekendpay": 0,
	"allowance": 0
})

const state = reactive({
	dialogVisible: false,
	captainOptions: [],
	form: createDefaultForm()
});

const showMenuPermission = computed(() => props.enableMenuPermission && Number(state.form.role_id) === ROLE_NORMAL_ADMIN);
const showSuperAdminHint = computed(() => props.enableMenuPermission && Number(state.form.role_id) === ROLE_SUPER_ADMIN);
const dialogWidth = computed(() => (showMenuPermission.value ? "920px" : "800px"));

const applyMenuTreeChecked = (savedPermissions) => {
	nextTick(() => {
		if (!menuTreeRef.value) return;
		const keys = resolveCheckedMenuKeys(savedPermissions);
		menuTreeRef.value.setCheckedKeys(keys, false);
	});
};

const selectAllMenus = () => {
	menuTreeRef.value?.setCheckedKeys(getAllAdminMenuPermissionKeys(), false);
};

const selectDefaultMenus = () => {
	menuTreeRef.value?.setCheckedKeys(resolveCheckedMenuKeys(getDefaultNormalAdminPermissions()), false);
};

const clearAllMenus = () => {
	menuTreeRef.value?.setCheckedKeys([], false);
};

const onRoleChange = (roleId) => {
	if (!props.enableMenuPermission) return;
	if (Number(roleId) === ROLE_NORMAL_ADMIN) {
		applyMenuTreeChecked(getDefaultNormalAdminPermissions());
	}
};

const loadCaptains = () => {
	if (!props.showCaptainSelect) {
		return;
	}
	pageListApi(JSON.stringify({
		page: 1,
		limit: 9999,
		keywords: '',
		role_id: 2,
	})).then((res) => {
		state.captainOptions = res?.data ?? [];
	});
};

const open = (row) => {
	state.dialogVisible = true;
	loadCaptains();
	if (row?.id) {
		const params = JSON.stringify({
			id: row.id
		})
		detailApi(params).then(res => {
			const { data } = res;
			const savedPermissions = parseMenuPermissions(data.menuPermissions ?? data.menu_permissions);
			state.form = {
				...data,
				"real_name": data.realName,
				"avatar_url": data.avatarUrl,
				"role_id": data.roleId,
				"english_name": data.englishName,
				"start_date": data.startDate,
				"end_date": data.endDate,
				"resignation_remark": data.resignationRemark || "",
				"account_remark": data.accountRemark || data.account_remark || "",
				"id_card": data.idCard,
			}
			if (Number(state.form.role_id) === ROLE_NORMAL_ADMIN) {
				applyMenuTreeChecked(savedPermissions ?? getDefaultNormalAdminPermissions());
			}
		})
	} else {
		state.form = {
			...createDefaultForm(),
			role_id: props.defaultRoleId || 1,
		};
	}
};

const close = () => {
	state.dialogVisible = false;
	state.form = createDefaultForm()
}

const collectMenuPermissions = () => {
	if (!showMenuPermission.value || !menuTreeRef.value) {
		return undefined;
	}
	const checked = menuTreeRef.value.getCheckedKeys(false);
	const halfChecked = menuTreeRef.value.getHalfCheckedKeys();
	return normalizeMenuPermissionPayload([...checked, ...halfChecked]);
};

const ruleForm = ref(null)
const submit = () => {
	ruleForm.value.validate((valid) => {
		if (valid) {
			let params = {
				...state.form
			}
			if (props.employmentOnlyEdit) {
				params = {
					id: state.form.id,
					employment: state.form.employment,
				}
			} else if (props.enableMenuPermission) {
				if (Number(state.form.role_id) === ROLE_NORMAL_ADMIN) {
					let perms = collectMenuPermissions()
					if (!perms.length) {
						perms = getDefaultNormalAdminPermissions()
					}
					params.menu_permissions = perms
				} else {
					params.menu_permissions = null
				}
			}
			delete params.idCard
			delete params.realName
			delete params.avatarUrl
			delete params.roleId
			delete params.englishName
			delete params.startDate
			delete params.endDate
			delete params.menuPermissions
			delete params.tenantId
			delete params.loginTime
			delete params.createdAt
			delete params.updatedAt
			delete params.password
			if (!props.showCaptainSelect || state.form.id > 0) {
				delete params.captain_id
			}
			saveApi(JSON.stringify(params)).then(res => {
				if (res?.code === 200) {
					state.dialogVisible = false;
					state.form = createDefaultForm()
					emit("refresh");
					ElMessage.success(t('common.success'));
				} else {
					ElMessage.error(res?.msg || t('common.failed'));
				}
			}).catch(() => {})
		} else {
			return false;
		}
	});
};

onMounted(() => {
	applyLabels();
});

defineExpose({ open, state });
</script>

<style lang="less" scoped>
.userAdd_man {
	min-height: 300px;
	max-height: 70vh;
	overflow: auto;
	padding: 0 30px;
}

.userFrom {
	display: flex;
	flex-wrap: wrap;
}

.el-form-item {
	margin-bottom: 0;
}

.menu-permission-block {
	width: 100%;
	margin-top: 8px;
	padding-top: 16px;
	border-top: 1px solid #ebeef5;
}

.menu-permission-head {
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-bottom: 8px;
}

.menu-permission-title {
	font-size: 14px;
	font-weight: 600;
	color: #303133;
}

.menu-permission-tip {
	margin: 0 0 12px;
	font-size: 12px;
	color: #909399;
	line-height: 1.5;
}

.super-admin-tip {
	margin: 0;
}

.menu-permission-tree {
	border: 1px solid #ebeef5;
	border-radius: 8px;
	padding: 12px 8px;
	max-height: 280px;
	overflow: auto;
}
</style>
